import { render } from "./font-awesome-icon.vue?vue&type=template&id=100d6839"
import script from "./font-awesome-icon.vue?vue&type=script&lang=ts"
export * from "./font-awesome-icon.vue?vue&type=script&lang=ts"
script.render = render

export default script